import { AlertTriangle, Check, LoaderCircle, Menu, Redo2, Undo2 } from 'lucide-react';
import { APP_VERSION } from '@/content/copy';
import type { EditorSnapshot } from '@/ports/editor';
import { IconButton } from '../IconButton';

interface TopBarProps {
  readonly snapshot: EditorSnapshot;
  readonly onMenu: () => void;
  readonly onUndo: () => void;
  readonly onRedo: () => void;
}

function SaveState({ snapshot }: { readonly snapshot: EditorSnapshot }) {
  if (snapshot.saveStatus === 'saving') {
    return <span className="save-state is-saving"><LoaderCircle className="spin" size={14} /> Guardando</span>;
  }
  if (snapshot.saveStatus === 'error') {
    return <span className="save-state is-error"><AlertTriangle size={14} /> No se pudo guardar</span>;
  }
  if (snapshot.saveStatus === 'saved') {
    return <span className="save-state is-saved"><Check size={14} /> Guardado</span>;
  }
  return <span className="save-state">Sin guardar</span>;
}

export function TopBar({ snapshot, onMenu, onUndo, onRedo }: TopBarProps) {
  return (
    <header className="editor-topbar">
      <button className="brand-button" type="button" onClick={onMenu} aria-label="Abrir menú de DG embalajes">
        <img src="/assets/icons/icon-192.png" alt="DG embalajes" />
        <span className="brand-button__copy">
          <strong>DG embalajes</strong>
          <small>{snapshot.projectName}</small>
        </span>
      </button>
      <SaveState snapshot={snapshot} />
      <div className="editor-topbar__actions">
        <IconButton icon={Undo2} label="Deshacer" disabled={!snapshot.canUndo} onClick={onUndo} />
        <IconButton icon={Redo2} label="Rehacer" disabled={!snapshot.canRedo} onClick={onRedo} />
        <span className="version-badge" aria-label={`Versión ${APP_VERSION}`}>{APP_VERSION}</span>
        <IconButton icon={Menu} label="Más acciones" onClick={onMenu} />
      </div>
    </header>
  );
}
